/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadReceipt
 */
export interface ReadReceipt {
    /**
     * 
     * @type {string}
     * @memberof ReadReceipt
     */
    referral_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReadReceipt
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof ReadReceipt
     */
    last_read_message_id: string;
    /**
     * 
     * @type {Date}
     * @memberof ReadReceipt
     */
    last_read_at: Date;
}

/**
 * Check if a given object implements the ReadReceipt interface.
 */
export function instanceOfReadReceipt(value: object): value is ReadReceipt {
    if (!('referral_id' in value) || value['referral_id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('last_read_message_id' in value) || value['last_read_message_id'] === undefined) return false;
    if (!('last_read_at' in value) || value['last_read_at'] === undefined) return false;
    return true;
}

export function ReadReceiptFromJSON(json: any): ReadReceipt {
    return ReadReceiptFromJSONTyped(json, false);
}

export function ReadReceiptFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadReceipt {
    if (json == null) {
        return json;
    }
    return {
        
        'referral_id': json['referral_id'],
        'user_id': json['user_id'],
        'last_read_message_id': json['last_read_message_id'],
        'last_read_at': (new Date(json['last_read_at'])),
    };
}

export function ReadReceiptToJSON(json: any): ReadReceipt {
    return ReadReceiptToJSONTyped(json, false);
}

export function ReadReceiptToJSONTyped(value?: ReadReceipt | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referral_id': value['referral_id'],
        'user_id': value['user_id'],
        'last_read_message_id': value['last_read_message_id'],
        'last_read_at': ((value['last_read_at']).toISOString()),
    };
}

